/**
 * Application-wide constants
 */
export class AppConstants {
  /** Company name for copyright notices */
  static readonly COMPANY_NAME = 'Two Hounds Development, LLC';
}
